import { useState } from 'react';
import ChatHeader from './ChatHeader';
import FormInputRenderer from './FormInputRenderer';
import { useFormValidation } from '../../hooks/iframe/useFormValidation';

const ChatForm = ({ 
  agent, 
  onClose, 
  onSubmit, 
  isMobile, 
  getPositionStyles 
}) => {
  const [formData, setFormData] = useState({});
  const { errors, validateForm } = useFormValidation(agent?.widget_settings?.form);

  const primaryColor = agent?.widget_settings?.primary_color || "#4309ffff";
  const welcomeMessage = agent?.widget_settings?.welcome_message;

  // Inicializar formData se ainda estiver vazio
  useState(() => {
    if (agent?.widget_settings?.form?.inputs && Object.keys(formData).length === 0) {
      const initialFormData = {};
      agent.widget_settings.form.inputs.forEach(input => {
        initialFormData[input.name] = '';
      });
      setFormData(initialFormData);
    }
  }, [agent, formData]);

  const handleFieldChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm(formData)) {
      onSubmit(formData);
    }
  };

  return (
    <div 
      style={!isMobile ? getPositionStyles() : {}} 
      className={`${isMobile ? 'fixed inset-0 z-50' : 'fixed z-50 transition-all w-96'}`}
    >
      <div className={`bg-white ${isMobile ? 'h-full flex flex-col' : 'rounded-3xl overflow-hidden h-[550px] flex flex-col'} shadow-md`}>
        <ChatHeader 
          agent={agent}
          onClose={onClose}
          primaryColor={primaryColor}
          title="Preencha os dados para iniciar"
          showForm={true}
          showCloseButton={true}
        />

        {/* Form Body */}
        <div className="flex-1 overflow-y-auto p-6 bg-gray-50">
          {/* Mensagem de Boas-Vindas */}
          {welcomeMessage && (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
              <h2 className="text-sm font-bold text-gray-900 mb-2">
                Bem vindo ao {agent?.name || 'Atendimento'}!
              </h2>
              <p className="text-gray-400 text-xs">
                Que bom ter você aqui!
                <br/><br/>
                Para iniciarmos o seu atendimento, preencha os dados abaixo.
              </p>
            </div>
          )}

          <form id="chat-form" onSubmit={handleSubmit} className="space-y-4">
            {agent?.widget_settings?.form?.inputs?.map((input, index) => (
              <div key={index}>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  {input.label}
                  {input.required && <span className="text-red-500 ml-1">*</span>}
                </label>
                <FormInputRenderer
                  input={input}
                  value={formData[input.name]}
                  onChange={(value) => handleFieldChange(input.name, value)}
                  error={errors[input.name]}
                  primaryColor={primaryColor}
                  stateValue={formData['state']} // Para filtrar cidades por estado
                />
                {errors[input.name] && (
                  <p className="text-red-500 text-xs mt-1">{errors[input.name]}</p>
                )}
              </div>
            ))}
          </form>
        </div>

        {/* Footer */}
        <div className="p-4 bg-white border-t border-gray-200">
          <button
            form="chat-form"
            type="submit"
            className="w-full py-3 text-white font-semibold rounded-lg transition-all 
                      transform hover:scale-[1.01] active:scale-[0.99] shadow-md"
            style={{ backgroundColor: primaryColor }}
          >
            Iniciar Conversa
          </button>
        </div>

        {/* Rodapé "Desenvolvido por" */}
        <div className="flex justify-center mb-4">
          <a 
            href="https://solteozap.com.br" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1"
          >
            <span>Desenvolvido por</span>
            <span className="font-semibold">{window.location.origin === "https://ia.solteozap.com.br" ? "Solte o Zap" : "QuoraAI"}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ChatForm;